<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col md="12">
                    <div class="wrapper-container text-right">
                        <img src="../assets/img/img_map.png" class="img-map" alt="">
                        <div class="text-wrapper">
                            <h1>We have National<br> Coverage in Mexico and<br> now expanded with clients<br>over the <span class="red">United States <br>of America</span></h1>
                            <p>
                                Provinco has a network of reliable distributors <br>in more than 15 states in Mexico. 
                            </p>
                            <p>
                                Now we are compromised to deliver our<br>top-notch service to the U.S. market.
                            </p>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.wrapper-container{
    position: relative;
}
.text-wrapper{
    position: absolute;
    text-align: left;
    top: 10%;
    left: 6%;
}
.img-map{
    margin-left: auto;
}
.text-right{
    text-align: right;
}

@media (max-width: 1600px){
  h1{
    font-size: 45px;
  }
  .img-map{
        width: 80%;
    }
}
@media (max-width: 968px){
    .text-wrapper{
        position: relative;
        text-align: left;
        top: 0;
        left: 0;
        padding: 6% 5%;
    }
}

@media (max-width: 768px){
  h1{
    font-size: 35px;
  }
}
</style>